import type { FlexibleDate } from '../types/medicalHistory';

/**
 * Parse a FHIR datetime string into a FlexibleDate object.
 * Handles year-only ("2015"), year-month ("2015-05"), and full dates ("2015-05-12").
 */
export function parseFlexibleDate(datetime: string | undefined): FlexibleDate | null {
  if (!datetime) return null;

  // Remove any time portion
  const dateOnly = datetime.split('T')[0];
  const parts = dateOnly.split('-');

  if (parts.length === 1 && parts[0].length === 4) {
    return { value: parts[0], precision: 'year' };
  } else if (parts.length === 2) {
    return { value: dateOnly, precision: 'month' };
  } else if (parts.length >= 3) {
    return { value: `${parts[0]}-${parts[1]}-${parts[2]}`, precision: 'day' };
  }

  return null;
}

/**
 * Extract the first note's text from a FHIR resource that has a `note` array.
 */
export function getNoteText(resource: { note?: Array<{ text?: string }> }): string {
  return resource.note?.[0]?.text || '';
}
